/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCrewBriefingFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeCrewBriefing, serializeCrewBriefingUpsertRequest, type CrewBriefing, type CrewBriefingUpsertRequest, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { PdfRequestBuilderRequestsMetadata, type PdfRequestBuilder } from './pdf/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter/{charter-id}/CrewBriefing
 */
export interface CrewBriefingRequestBuilder extends BaseRequestBuilder<CrewBriefingRequestBuilder> {
    /**
     * The Pdf property
     */
    get pdf(): PdfRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CrewBriefing>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CrewBriefing | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CrewBriefing>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     put(body: CrewBriefingUpsertRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CrewBriefing | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: CrewBriefingUpsertRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CrewBriefingRequestBuilderUriTemplate = "{+baseurl}/Charter/{charter%2Did}/CrewBriefing";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CrewBriefingRequestBuilderNavigationMetadata: Record<Exclude<keyof CrewBriefingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    pdf: {
        requestsMetadata: PdfRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const CrewBriefingRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: CrewBriefingRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCrewBriefingFromDiscriminatorValue,
    },
    put: {
        uriTemplate: CrewBriefingRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCrewBriefingFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCrewBriefingUpsertRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
